import Base from '../Base';
import Swiper from 'swiper';
export default class ActiveTransportation extends Base {
    init(id, main, locale) {
        console.log(':: ActiveTransportation ::');

        const startingSlide = Math.floor(Math.random() * 3);
        let charactersSwiper;
        let iconHumansSwiper;
        let iconTransportsSwiper;

        let timerSwipers;

        initSwipers();

        function initSwipers() {
            charactersSwiper = new Swiper('#swiper-characters', {
                allowTouchMove: false,
                initialSlide: startingSlide,
                loop: true,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                slidesPerView: 1,
                speed: 600,
                on: {
                    init() {
                        document.querySelector('.characters-wrapper').style.opacity = 1;
                    },
                },
            });
            // Lateral move when changing slide
            // charactersSwiper.on('slideChangeTransitionStart', () => {
            //     charactersSwiper.slides[charactersSwiper.activeIndex - 1].querySelector('.character').classList.add('move');
            // });
            // charactersSwiper.on('slideChangeTransitionEnd', () => {
            //     charactersSwiper.slides[charactersSwiper.activeIndex - 1].querySelector('.character').classList.remove('move');
            // });

            iconHumansSwiper = new Swiper('#swiper-icon-humans', {
                allowTouchMove: false,
                initialSlide: startingSlide,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                loop: true,
                slidesPerView: 1,
                speed: 400,
            });
            iconTransportsSwiper = new Swiper('#swiper-icon-transports', {
                allowTouchMove: false,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                loop: true,
                slidesPerView: 1,
                speed: 400,
            });
            initInterval();
        }
        function initInterval() {
            let count = 1;
            timerSwipers = setInterval(()=> {
                iconTransportsSwiper.slideNext();
                if (count % 3 == 0) {
                    // Change all icons every 4.5s/three interval repeats
                    charactersSwiper.slideNext();
                    iconHumansSwiper.slideNext();
                }
                count++;
            }, 1500);
        }
    }
}